import { Component, OnInit, HostBinding } from '@angular/core';
import { ConfigService } from '@argalis-apps/angular-global';
import { MUser } from '@argalis-apps/models';
import { AuthService } from '../../../../auth/services/auth/auth.service';
import { CalendarService } from '../../../services/calendar/calendar.service';

@Component({
  selector: 'ags-footer-calendar',
  templateUrl: './footer-calendar.component.html',
  styleUrls: ['./footer-calendar.component.scss']
})
export class FooterCalendarComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  public id: number;
  public isInter: boolean;
  public userConnected: MUser.CUser;
  public horaireOf;

  constructor(
    private configService: ConfigService,
    private authService: AuthService,
    private calendarService: CalendarService
  ) {
    this.isInter =
      this.configService
        .getETypeUser()
        .valueOf()
        .valueOf() === MUser.ETypeUser.FORMATEUR.valueOf();
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });
    this.id = this.userConnected.userInfo.id;
  }

  ngOnInit() {
    this.calendarService.getHoraireOf(this.id).subscribe(horaire => {
      if (horaire && Array.isArray(horaire) && (horaire[0] || ({} as any)).dernier_numero_facture) {
        this.horaireOf = horaire[0].dernier_numero_facture;
      }
    });
  }
}
